module.exports = __webpack_public_path__ + "img/7-112.9143a0f3.png";